import Vue from 'vue';
import _ from 'lodash';
import gql from 'graphql-tag';

import graphqlClient from '../../helpers/graphql';

const state = {
  homePageMenuPhoto: null,
  homePageImportantMessage: null,
  articles: [],
  sponsors: [],
  subscriptionTypes: []
};

const mutations = {
  setHomePageMenuPhoto(state, config) {
    Vue.set(state, 'homePageMenuPhoto', config);
  },
  setHomePageImportantMessage(state, config) {
    Vue.set(state, 'homePageImportantMessage', config);
  },
  setArticles(state, articles) {
    Vue.set(state, 'articles', articles);
  },
  setSponsors(state, sponsors) {
    Vue.set(state, 'sponsors', sponsors);
  },
  setSubscriptionTypes(state, subscriptionTypes) {
    Vue.set(state, 'subscriptionTypes', subscriptionTypes);
  }
};

const actions = {
  async fetchConfigs({ commit }) {
    const response = await graphqlClient.query({
      // It is important to not use the
      // ES6 template syntax for variables
      // directly inside the `gql` query,
      // because this would make it impossible
      // for Babel to optimize the code.
      query: gql`
        query {
          homePageMenuPhoto {
            text
            photo {
              url
            }
            display
          }
          homePageImportantMessage {
            text
            type
            display
            title
          },
          articles(where: {show: true}, sort: "date:desc",) {
            id
            title
            content
            date
            type
          },
          sponsors(where: {display: true}) {
            name
            description
            photo {
              url
            }
            photoFull {
              url
            }
            order
          },
          subscriptionTypes(where: {display: true}) {
            id
            name
            price
            durationInYear
            description
            allowMultipleMembers
          }
        }
      `
    });
    commit('setHomePageMenuPhoto', response.data.homePageMenuPhoto);
    commit('setHomePageImportantMessage', response.data.homePageImportantMessage);
    commit('setArticles', response.data.articles);
    commit('setSponsors', response.data.sponsors);
    commit('setSubscriptionTypes', response.data.subscriptionTypes);
  }
};

const getters = {
  articles: state => {
    return state.articles;
  }
};

export const config = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
